import { LayoutMain } from '@/src/layouts/LayoutMain/LayoutMain'
import { AdminRoute } from '@/src/routes/AdminRoute'
import React, { Suspense } from 'react'
import type { RouteObject } from 'react-router-dom'
import { AuthRoute } from '../../../routes/routes.components'

const PersonalInformationLazy = React.lazy(() => import('./screens/PersonalInformation.screen'))
const CompanyInformationLazy = React.lazy(() => import('./screens/CompanyInformation.screen'))
//const NotificationSettingsLazy = React.lazy(() => import('./screens/NotificationSettings/NotificationSettings.screen'))
const ChangePasswordLazy = React.lazy(() => import('./screens/ChangePassword.screen'))
const IntegrationsLazy = React.lazy(() => import('./screens/Integrations.screen'))
const DataExportLazy = React.lazy(() => import('../../datenmanagement/export/DataExport.screen'))
const EnergyCostAndBudgetLazy = React.lazy(() => import('./screens/EnergyCostAndBudget/EnergyCostAndBudget.screen'))
const ElectricityAnalysisLazy = React.lazy(() => import('./screens/ElectricityAnalysis/ElectricityAnalysis.screen'))
const UsersLazy = React.lazy(() => import('./screens/Users/Users.screen'))
const Iso50001Lazy = React.lazy(() => import('./screens/Iso50001/Iso50001.screen'))
const LocationSettingsLazy = React.lazy(() => import('./screens/LocationSettings/LocationSettings.screen'))

const profilePaths = {
  profile: 'profile',
  changePassword: 'change-password',
  personalInfo: 'personal-info',
  companyInfo: 'company-info',
  locationSettings: 'location-settings',
  users: 'users',
  files: 'files',
  //notificationsSettings: 'notification-settings',
  integrations: 'integrations',
  electricityAnalysis: 'electricity-analysis',
  dataExport: 'data-export',
  procurement: 'procurement',
  energyCostAndBudget: 'stromkosten-budget',
  iso50001: 'iso-50001',
  onboarding: 'onboarding',
}

export const profileRoutes: RouteObject[] = [
  {
    path: profilePaths.profile,
    element: (
      <AuthRoute>
        <Suspense fallback={<div></div>}>
          <LayoutMain />
        </Suspense>
      </AuthRoute>
    ),
    children: [
      {
        path: profilePaths.personalInfo,
        element: (
          <Suspense fallback={<div></div>}>
            <PersonalInformationLazy />
          </Suspense>
        ),
      },
      {
        path: profilePaths.changePassword,
        element: (
          <Suspense fallback={<div></div>}>
            <ChangePasswordLazy />
          </Suspense>
        ),
      },
      {
        path: profilePaths.companyInfo,
        element: (
          <Suspense fallback={<div></div>}>
            <CompanyInformationLazy />
          </Suspense>
        ),
      },
      {
        path: profilePaths.locationSettings,
        element: (
          <Suspense fallback={<div></div>}>
            <LocationSettingsLazy />
          </Suspense>
        ),
      },
      {
        path: profilePaths.electricityAnalysis,
        element: (
          <Suspense fallback={<div></div>}>
            <ElectricityAnalysisLazy />
          </Suspense>
        ),
      },
      /*{
        path: profilePaths.notificationsSettings,
        element: (
          <Suspense fallback={<div></div>}>
            <NotificationSettingsLazy />
          </Suspense>
        ),
      },*/
      {
        path: profilePaths.integrations,
        element: (
          <Suspense fallback={<div></div>}>
            <IntegrationsLazy />
          </Suspense>
        ),
      },
      {
        path: profilePaths.dataExport,
        element: (
          <Suspense fallback={<div></div>}>
            <DataExportLazy />
          </Suspense>
        ),
      },
      {
        path: profilePaths.energyCostAndBudget,
        element: (
          <Suspense fallback={<div></div>}>
            <EnergyCostAndBudgetLazy />
          </Suspense>
        ),
      },
      {
        path: profilePaths.users,
        element: (
          <AdminRoute>
            <Suspense fallback={<div></div>}>
              <UsersLazy />
            </Suspense>
          </AdminRoute>
        ),
      },
      {
        path: profilePaths.iso50001,
        element: (
          <Suspense fallback={<div></div>}>
            <Iso50001Lazy />
          </Suspense>
        ),
      },
    ],
  },
]
